const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 10,
		supportOnScrollLazyloading: true,
		preventSortOfField: {
			tags: true
		},
		buttonContext: 'addressConnection',
		showHead: true,
		showInsertButton: true,
		rowActionsProperties: {
			colWidth: '164px'
		},
		rowActions: {
			delete: true,
			customs: [{
				buttonType: 'move',
				buttonContext: 'address',
				mode: 'down'
			},{
				buttonType: 'move',
				buttonContext: 'address',
				mode: 'up'
			},{
				buttonType: 'showEdit',
				buttonContext: 'address',
				mode: 'details'
			}]
		},
		forceResourceFilterPreparation: true
	},

	methods: {
		dataDealer: function(){
			this.model.parentAddressID = (this.getResourceRegisterContent('relation') || {}).entityID;
			this.config.preventRender = !this.model.parentAddressID;
		},

		showInsert: function(){
			var baseActionKey = 'showInsert_addressConnection';

			if(this.actions[baseActionKey]){
				return this.performAndStoreAction(
					baseActionKey + '_inEffect',
					this.prepareAction(baseActionKey, undefined, {
						grantAllAddressTypes: true,
						selection: {
							connectionInclusive: true,
							hasActiveNewsletterEmail: null,
						}
					}),
					true
				);
			}
		},
		showEdit: function(addressID, addressData, buttonMode){
			var self = this;
			if(buttonMode === 'details'){
				self.closest('templates_artCrm_address_recordController', function(recordController){
					recordController.find('templates_artCrm_address_propertiesForm', function(propertiesForm){
						recordController.showEdit('details', undefined, addressID, (propertiesForm.resourceData.data || {}).attributes || {}, (addressData || {}).attributes || {});
					});
				});
			}
			else {
				getComponent('artCrmController').showEdit('address', addressID, addressData);
			}
		},
		delete: function(addressID){
			var self = this;
			if(addressID && self.model.parentAddressID){
				return self.performDecision(
					'confirm',
					{
						component:  self,
						title:      storage.__('hint.delete.really.' + self.config.buttonContext + '.title'),
						message:    storage.__('hint.delete.really.' + self.config.buttonContext + '.message')
					}
				).then(function(context) {
					if (context.decision.type === 'yes') {
						return $.ajax({
							url: '/~/artcrm/addressConnections/' + self.model.parentAddressID + '/' + addressID,
							cache: false,
							method: 'DELETE',
							json: true
						}).fail(function(error){
							return self.performAction(
								self.prepareAction('message', undefined, {
									messageDisplay: {
										message: 'error:delete.artcrm_addressConnections'
									}
								}, {
									rollbackContext: context,
									statusControllerLoadingMessage: '',
									statusControllerSavingMessage:  ''
								})
							);
						}).then(function(){
							self.refreshData();
							self.callHandler('recordControllerResourcesModified');
							return context;
						});
					}

					return utils.promise.reject();
				});
			}
		},
		move: function(addressID, addressData, buttonMode){
			var self = this;
			var resources = [];

			// prepare resources to prevent issues caused by lazyloading
			for(var entityID in self.model.entityList || {}){
				var rowIndex = (self.model.entityList[entityID] || {}).index;
				if(rowIndex !== undefined){
					resources[rowIndex * 1] = self.model.entityList[entityID];
				}
			}

			self.model.recordController.backupScrollPosition();
			self.model.recordController.move(resources, self.model.parentAddressID, addressID, buttonMode || '').then(function(){
				self.refreshData(true, { restoreScrollPosition: true });
			});
		},

		addEntity: function(entity){
			if(this.config.isReady && this.model.$table){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }))
			}
		},

		onFilterChanged: function(){},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			if((resourceFilters || {}).filters){
				if(actionKey === 'delete_addressConnection' && this.model.parentAddressID && this.model.targetAddressID){
					resourceFilters.filters.sourceAddressID = this.model.parentAddressID;
					resourceFilters.filters.targetAddressID = this.model.targetAddressID;
					delete resourceFilters.filters.addressID;
				} else if(actionKey === 'refreshResources') {
					resourceFilters.filters.addressID = this.model.parentAddressID;
					resourceFilters.order = [{
						fieldCode: 	'sort',
						direction: 	'ASC NULLS LAST'
					},{
						fieldCode: 	'addressID',
						direction: 	'DESC NULLS FIRST'
					}];
					delete resourceFilters.filters.sourceAddressID;
					delete resourceFilters.filters.targetAddressID;
				}
			}
		},

		get$ScrollContainer: function(event){
			return this.$.closest('.templates_artCrm_address_propertiesForm').closest('section.main');
		},
		get$FullHeightContainer: function(event){
			return this.$.closest('.templates_artCrm_address_propertiesForm > .cols');
		},

		onBeforeLazyLoad: function(){
			if(this.model.recordController){
				this.model.recordController.backupScrollPosition();
			}
		},
		onAfterLazyLoad: function(errorOccurred){
			if(this.model.recordController){
				this.model.recordController.restoreScrollPosition();
			}
		},
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.recordController){
				self.closest('templates_artCrm_entity_recordController', function(controller){
					self.model.recordController = controller
				});
			}
			if(!self.model.controller && self.model.recordController){
				self.model.recordController.closest('base_tabStrip_tabStrip', function(tabStrip){
					tabStrip.find('templates_artCrm_entity_controller', function(controller){
						self.model.controller = controller;
						controller.find('templates_artCrm_address_table', function(addressTable){
							self.model.controllersAddressTable = addressTable;
						});
					});
				});
			}
			self.model.$table = $element.find('table');

			if(options.restoreScrollPosition && self.model.recordController){
				self.model.recordController.restoreScrollPosition();
			}
		},

		async onDecision($element, options){
			options = options || {};

			switch(options.decisionType){
				case 'addressSelected':
					var sourceAddressID, targetAddressID;
					if((sourceAddressID = this.model.parentAddressID) && (targetAddressID = options.addressID)){
						await this.performAction(this.prepareAction('insert_addressConnection', undefined, undefined, {
							source: {
								submit: {
									data: {
										data: {
											attributes: {
												sourceAddressID,
												targetAddressID
											}
										}
									}
								}
							}
						}))
						let modal
						options.decisionComponent.closest('base_modal_modal', c => modal = c)
						if(modal){
							await modal.hide()
						}

						this.callHandler('recordControllerResourcesModified');
						this.refreshData();

						var statusController;
						if((statusController = getComponent('statusController'))){
							statusController.addPanel('status.done.save');
						}
					}

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide();
							break;
					}
					break;

				default:
					break;
			}
		}
	},

	handlers: [{
		name: 'recordControllerResourcesModified',
		handle: function(callerComponent) {
			if((
				callerComponent.config.entityContext === 'address' ||
				callerComponent.config.entityContext === 'addressConnection'
			) && this.config.isReady){
				this.refreshData();
			}
		}
	}]
}
